import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestData } from 'src/app/common/models/request-data.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SaleItemDisplayOrderService {

  constructor(private http: HttpClient) { }

  getMenuDepartmentList(requestData:RequestData): Observable<any> {
    // Replace with your actual API endpoint
    return this.http.post(environment.baseUrl+'/menu/get', requestData);
  }

  getSubClassListByDepartmentId(menuId: number): Observable<any> {
    // Replace with your actual API endpoint
    return this.http.get(environment.baseUrl + '/sale-item-display-order/subclass/' + menuId);
  }

  getSaleItemDisplayOrderBySubClassId(data: any): Observable<any> {
    // Replace with your actual API endpoint
    return this.http.post(environment.baseUrl + '/sale-item-display-order/get',data);
  }
  /**
     * 
     * @param reasonsInfo 
     * Calls the update API to insert/update the record
     */
     update(itemClassInfo:any): Observable<any> { 
        return this.http.post(environment.baseUrl+'/sale-item-display-order/update', itemClassInfo);

    }
}
